/** @format */

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { Locale } from "./init";

/**
 * To be used with React Router Dom to use the first URL param as the current locale.
 * Redirects the URL to the current locale if not matching.
 * e.g. <Route path="/en" element={<LocaleWrapper locale="en"/>}> ... Child Routes ... </Route>
 */
const LocaleWrapper: React.FC<{ locale: Locale }> = ({ locale: urlLocale }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(urlLocale);
  }, [urlLocale, i18n]);

  // useEffect(() => {
  //   if (locale && locale !== urlLocale) setRedirect(true)
  // }, [locale, urlLocale])

  return <Outlet />;
};

export default LocaleWrapper;
